import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AnswersComponent } from '../answers/answers.component';
import { CeIconComponent } from '@enginuity/core/atoms/ce-icon/ce-icon.component';
import { ButtonsComponent } from '@enginuity/core/molecules/buttons/buttons.component';
import { SecondaryBtnsComponent } from '@enginuity/core/molecules/secondary-btns/secondary-btns.component';
import { SearchComponent } from '@enginuity/core/molecules/search/search.component';
import { InfoComponent } from '../info/info.component';
import { InputsComponent } from '@enginuity/core/molecules/inputs/inputs.component';
import { ProductBlockComponent } from '../product-block/product-block.component';
import { ReactiveFormsModule } from '@angular/forms';
import { ModalService } from '@services/core-services/modal.service';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  standalone: true,
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss'],
  imports: [
    CommonModule,
    AnswersComponent,
    CeIconComponent,
    ButtonsComponent,
    SecondaryBtnsComponent,
    SearchComponent,
    InfoComponent,
    InputsComponent,
    ProductBlockComponent,

    ReactiveFormsModule,
  ],
})
export class ModalComponent {
  @Output() modalEvent = new EventEmitter<any>();
  @Output() customClick = new EventEmitter<any>();
  @Input() modalDetail: any = {
    modalHeading: 'You are about to reject the KYC',
    modalDescription: 'Please select a reason for rejecting the document',
    topIcon: 'warning',
    alertContent: 'This is an example of a not important notification.',
    calendarLabel: 'Current schedule',
    alertColor: 'red',
    alertBar: false,
    showCalander: false,
    showContent: true,
    showIcon: true,
    showBtns: true,
    showInput: false,
    showProduct: false,
    answerDirection: true,
    answerWidth: 'full',
    search: false,
    input: [
      {
        label: 'Label',
        name: 'name',
        form: 'refundForm',
        active: false,
        placeholder: 'placeholder content',
        dropdown: false,
        prefix: false,
        dropdownItems: [
          {
            value: 'option1',
            label: 'Option 1',
          },
          {
            value: 'option2',
            label: 'Option 2',
          },
          {
            value: 'option3',
            label: 'Option 3',
          },
        ],
      },
    ],
    products: [
      {
        productImage: '/assets/product.jpg',
        productName: 'Sunglasses',
        productPrice: '0.00',
        stock: 'In stock',
        badges: {
          Type: 'completed',
          withIcon: true,
          IconType: 'dot',
          label: 'Active',
        },
        available: true,
      },
    ],
    answer: [
      {
        type: 'answer1',
        label: 'I sell my products to consumer',
        inputPlaceholder: 'Type the answer...',
        badgelabel: 'A',
        numbring: false,
        input: false,
      },
    ],
    primaryBtn: {
      label: 'Reject KYC',
      active: false,
      alert: true,
      disabled: false,
      continueBtn: true,
    },
    secondaryBtn: {
      label: 'Cancel',
      backBtn: true,
    },
  };

  constructor(
    private readonly modal: ModalService,
    private modalRef: MatDialogRef<any>
  ) {}

  selected(event: any) {
    this.customClick.emit({
      action: 'redirect',
      value: event.value,
    });
  }

  onActions(event: any) {
    if (event === 'confirm' && this.modalDetail.modalType === 'saveView') {
      const params = {
        action: 'confirm',
        value: this.modalDetail.input?.[0]?.form?.value,
      };
      this.customClick.emit(params);
      this.modalRef.close(params);
    } else {
      this.customClick.emit(event);
      this.modalRef.close({ action: 'cancel' });
    }
  }

  onSecondary(_: any) {
    this.customClick.emit('cancel');
    this.modalRef.close();
  }
}
